import api from './api';
import { Tender, TenderFormData, ApiResponse } from '../../types/tenders.types';

function toFormData(data: TenderFormData, file?: File): FormData {
  const fd = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      fd.append(key, String(value));
    }
  });
  if (file) fd.append('document', file);
  return fd;
}

export const tendersService = {
  getAll: async (status?: string): Promise<ApiResponse<Tender[]>> => {
    const url = status ? `/api/tenders?status=${status}` : '/api/tenders';
    const response = await api.get<ApiResponse<Tender[]>>(url);
    return response.data;
  },

  getActive: async (): Promise<ApiResponse<Tender[]>> => {
    const response = await api.get<ApiResponse<Tender[]>>('/api/tenders/active');
    return response.data;
  },

  getById: async (id: number): Promise<ApiResponse<Tender>> => {
    const response = await api.get<ApiResponse<Tender>>(`/api/tenders/${id}`);
    return response.data;
  },

  create: async (data: TenderFormData, file?: File): Promise<ApiResponse<Tender>> => {
    const fd = toFormData(data, file);
    const response = await api.post<ApiResponse<Tender>>('/api/tenders', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  update: async (id: number, data: TenderFormData, file?: File): Promise<ApiResponse<Tender>> => {
    const fd = toFormData(data, file);
    const response = await api.put<ApiResponse<Tender>>(`/api/tenders/${id}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  updateStatus: async (id: number, status: string): Promise<ApiResponse<Tender>> => {
    const response = await api.put<ApiResponse<Tender>>(`/api/tenders/${id}/status`, { status });
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/api/tenders/${id}`);
    return response.data;
  },
};
